import { useEffect, useRef } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import TaskViewCardCta from './TaskViewCardCta';
import { useDismissTaskCard } from '../../../contexts/TaskCardsContext';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompletedTaskView = ({
  viewConfig,
  groupKey
}) => {
  const dismissOnUnmount = viewConfig && viewConfig.dismissOnUnmount ? viewConfig.dismissOnUnmount : false;
  const dismissTaskCard = useDismissTaskCard();
  const {
    trackSectionView
  } = useTracker();
  const maybeDismissTaskCardRef = useRef(dismissOnUnmount ? () => dismissTaskCard(groupKey) : () => {});

  // If the user leaves User Guide or views another tab, we want this completed
  // card to dismiss itself and be hidden for the next time the user sees the
  // page.
  useEffect(() => {
    return maybeDismissTaskCardRef.current;
  }, [maybeDismissTaskCardRef]);
  useEffect(() => {
    trackSectionView('task view card completion state', groupKey);
  }, [trackSectionView, groupKey]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "task-group-completed-view",
    flexDirection: "column",
    justifyContent: "center",
    paddingBlockEnd: "200",
    rowGap: "200",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "success-green",
      width: 55
    }), /*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      children: viewConfig ? viewConfig.title : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.consolidatedUserGuide.taskViewCard.defaultCompletedState.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      children: viewConfig ? viewConfig.description : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.consolidatedUserGuide.taskViewCard.defaultCompletedState.description"
      })
    }), viewConfig && /*#__PURE__*/_jsx(TaskViewCardCta, {
      config: viewConfig.cta,
      "data-test-id": "task-goal-completed-cta",
      groupKey: groupKey,
      onClick: () => dismissTaskCard(groupKey),
      size: "medium",
      use: "primary"
    })]
  });
};
export default CompletedTaskView;